<template>
  <div class="page-wrap">
    <el-card shadow="never">
      <div class="toolbar">
        <el-date-picker
            v-model="times"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
        <el-select v-model="query.storeId" filterable placeholder="门店" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in storeList" :key="opt.id" :label="opt.storename" :value="opt.id" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="fetchList">查询</el-button>
        <el-button type="success" icon="el-icon-upload" @click="exportOrders('1')">导出</el-button>
      </div>
      <el-table :data="list" border stripe v-loading="loading" style="width:100%">
        <el-table-column prop="storename" label="门店名称" width="300"/>
        <el-table-column prop="uid" label="宝付ID" width="200"/>
        <el-table-column prop="allBalance" label="总收入"/>
        <el-table-column prop="sxf" label="服务费"/>
        <el-table-column prop="reallyBalance" label="实际收入"/>
        <el-table-column prop="allQk" label="应收账款"/>
        <el-table-column prop="txBalance" label="已提金额"/>
        <el-table-column prop="qkkc" label="扣除账款"/>
        <el-table-column prop="syqk" label="剩余账款"/>
        <el-table-column prop="syBalance" label="当前余额"/>
        <el-table-column label="操作" width="240" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="goBalanceLog(row)">流水记录</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="text" v-permission="'btn:finance:bf:qk'" @click="goQkFlag(row)">欠款录入</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
            background
            layout="total, prev, pager, next, sizes"
            :total="total"
            :current-page.sync="query.page"
            :page-size.sync="query.pageSize"
            :page-sizes="[10,20,50,100]"
            @current-change="fetchList"
            @size-change="fetchList"
        />
      </div>
    </el-card>

    <el-dialog
        title="流水记录"
        fullscreen
        :visible.sync="balanceVisible">
      <el-card shadow="never">
        <div class="toolbar">
          <el-date-picker
              v-model="times2"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-select v-model="queryBalance.type" placeholder="类型" clearable style="width:220px;margin-right:12px">
            <el-option v-for="opt in typeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
          <el-select v-model="queryBalance.opType" placeholder="操作类型" clearable style="width:220px;margin-right:12px">
            <el-option v-for="opt in opTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getBalanceList">查询</el-button>
          <el-button
              type="primary"
              icon="el-icon-upload"
              @click="exportOrders('2')"
              :loading="exporting"
          >导出Excel</el-button>
        </div>
        <el-table :data="balanceList" border stripe v-loading="balanceLoading" style="width:100%">
          <el-table-column prop="orderNo" label="流水号" width="300" show-overflow-tooltip/>
          <el-table-column prop="storename" label="门店名称" width="300"/>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.type == '0'">美团</el-tag>
              <el-tag type="warning" v-else-if="scope.row.type == '1'">抖音</el-tag>
              <el-tag type="primary" v-else-if="scope.row.type == '2'">欠款</el-tag>
              <el-tag type="success" v-else-if="scope.row.type == '3'">提现</el-tag>
              <el-tag type="info" v-else-if="scope.row.type == '4'">还款</el-tag>
              <el-tag type="info" v-else-if="scope.row.type == '5'">返佣</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作类型">
            <template slot-scope="scope">
              <el-tag type="priamry" v-if="scope.row.opType == '0'">收入</el-tag>
              <el-tag type="success" v-else>支出</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="金额"/>
          <el-table-column prop="syBalance" label="当前余额"/>
          <el-table-column prop="sxf" label="手续费"/>
          <el-table-column prop="username" label="提现用户"/>
          <el-table-column prop="remark" label="备注"/>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.type == '3'">
                <el-tag type="success" v-if="scope.row.auditStatus == '1' && scope.row.status == '0'">成功</el-tag>
                <el-tag type="primary" v-else-if="scope.row.auditStatus == '1' && scope.row.status == '2'">银行处理中</el-tag>
                <span v-else-if="scope.row.auditStatus == '1' && scope.row.status == '1'">提现失败：{{scope.raw.msg}}</span>
                <el-tag type="primary" v-else-if="scope.row.auditStatus == '0'">审核中</el-tag>
                <span type="primary" v-else-if="scope.row.auditStatus == '2'">审核失败：{{scope.row.auditError}}</span>
              </div>
              <el-tag type="success" v-else-if="scope.row.status == '0'">成功</el-tag>
              <el-tag type="primary" v-else-if="scope.row.status == '2'">处理中</el-tag>
              <span v-else-if="scope.row.status == '1'">{{scope.raw.msg}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTimeStr" label="操作时间"/>
        </el-table>
        <div class="pager">
          <el-pagination
              background
              layout="total, prev, pager, next, sizes"
              :total="totalBalance"
              :current-page.sync="queryBalance.page"
              :page-size.sync="queryBalance.pageSize"
              :page-sizes="[10,20,50,100]"
              @current-change="getBalanceList"
              @size-change="getBalanceList"
          />
        </div>
      </el-card>
    </el-dialog>

    <el-dialog
        title="欠款录入"
        :visible.sync="qkVisible">
      <el-form :model="qkForm" :rules="qkRules" ref="qkFormRef" label-width="100px">
        <el-form-item label="扣除金额" prop="price">
          <el-input v-model="qkForm.price" placeholder="请输入扣除金额"></el-input>
        </el-form-item>
        <el-form-item label="扣除原因" prop="remark">
          <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入扣除原因"
              v-model="qkForm.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qkVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitQk" v-loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 说明：接口路径与后端保持一致，下面以 /api/open-account 为示例
import axios from 'axios'
import { Loading } from "element-ui";
export default {
  name: 'OpenAccountList',
  data(){
    return {
      btnLoading: false,
      exporting: false,
      typeOptions:[
        {label:'美团', value:'0'},
        {label:'抖音', value:'1'},
        {label:'提现', value:'3'},
        {label:'还款', value:'4'},
      ],
      opTypeOptions:[
        {label:'收入', value:'0'},
        {label:'支出', value:'1'}
      ],
      times: [],
      times2: [],
      balanceVisible:false,
      qkVisible:false,
      loading:false,
      balanceLoading:false,
      list:[],
      balanceList:[],
      storeList:[],
      total:0,
      totalBalance:0,
      storeName: null,
      query:{
        page:1,
        pageSize:10,
        storeId: null,
        startTime: null,
        endTime: null
      },
      queryBalance:{
        page:1,
        pageSize:10,
        storeId: null,
        opType: null,
        type: null,
        startTime: null,
        endTime: null
      },
      qkForm: {
        uid: null,
        storeId: null,
        price: null,
        remark: null
      },
      qkRules: {
        price:[
          { required: true, message: '请输入扣除金额', trigger: 'blur' },
          { pattern: /^(([2-9]|([1-9]\d{1,6}))(\.\d{1,2})?)$/, message: '扣除金额只能是数值最大为9999999,最小为2,最多2位小数', trigger: 'blur' }
        ],
        remark:[
          { required: true, message: '请输入扣除原因', trigger: 'blur' },
          { max: 100, message: '最大长度为100字符', trigger: 'change' }
        ]
      }
    }
  },
  created(){
    this.fetchList();
    this.getList();
  },
  watch:{
    balanceVisible: (val, oldVal) => {
      if (!val) {
        this.queryBalance.storeId = null
      }
    }
  },
  methods:{
    async getList(){
      const { data:res } = await this.$http.get('open-account/getStoresAll/')
      this.storeList = res.data
      this.storeList.push({id: '-1', storename: '公司账户'})
    },
    async fetchList(){
      this.loading=true
      try{
        if (this.times && this.times.length > 0){
          this.query.startTime = this.times[0]
          this.query.endTime = this.times[1]
        }
        const {data} = await axios.post('/open-account/bfBalanceList/',this.query)
        if(data.code == 200){
          this.list=data.data.list||[]
          this.total=data.data.total||0
        }else{ this.$message.error(data.msg||'查询失败') }
      }catch(e){ this.$message.error('查询异常'); console.error(e) }
      finally{ this.loading=false }
    },
    async getBalanceList(){
      this.balanceLoading=true
      if (this.times2 && this.times2.length > 0){
        this.queryBalance.startTime = this.times2[0]
        this.queryBalance.endTime = this.times2[1]
      }
      try{
        const {data} = await axios.post('/open-account/bfBalanceLogList/',this.queryBalance)
        if(data.code == 200){
          this.balanceList=data.data.list||[]
          this.balanceList.forEach(item=>{
            item.storename = this.storeName
          })
          this.totalBalance=data.data.total||0
        }else{ this.$message.error(data.msg||'查询失败') }
      }catch(e){ this.$message.error('查询异常'); console.error(e) }
      finally{ this.balanceLoading=false }
    },
    // 导出流水数据
    exportOrders(val) {
      if (val == '1') {
        if (this.times.length === 0) {
          this.$message.warning('请选择日期范围再进行导出')
          return
        }

        this.queryBalance.startTime = this.times[0]
        this.queryBalance.endTime = this.times[1]
      } else if (this.times2 && this.times2.length > 0){
        this.queryBalance.startTime = this.times2[0]
        this.queryBalance.endTime = this.times2[1]
      }

      this.queryBalance.storeId = this.query.storeId

      let downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
          .get("/open-account/bfBalanceLogList/export", {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            responseType: "blob",
            params: this.queryBalance,
          })
          .then(async (data) => {
            const isBlob = data.data.type !== "application/json";
            if (isBlob) {
              const blob = new Blob([data.data]);
              saveAs(blob, `流水数据_${new Date().getTime()}.xlsx`);
            } else {
              this.$message.error("导出订单数据失败");
            }
            downloadLoadingInstance.close();
          })
          .catch((r) => {
            console.error(r);
            this.$message.error("下载文件出现错误，请联系管理员！");
            downloadLoadingInstance.close();
          });
    },
    goBalanceLog(row){
      this.storeName = row.storename;
      this.queryBalance.storeId = row.storeId;
      this.queryBalance.page = 1
      this.queryBalance.startTime = null
      this.queryBalance.endTime = null

      this.getBalanceList()
      this.balanceVisible = true
    },
    goQkFlag(row){
      this.qkForm.uid = row.uid;
      this.qkForm.storeId = row.storeId;
      this.qkForm.payAccountNo = row.bankAccountNo;
      this.qkForm.price = null
      this.qkForm.remark = null
      this.qkVisible = true
    },
    handleSubmitQk() {
      this.$refs.qkFormRef.validate(valid => {
        if (!valid) return
        this.btnLoading = true

        // 提交数据：在此处调用 API
        axios.post('/open-account/qkKc', this.qkForm)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('扣除成功')
              this.fetchList()
              this.qkVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => this.$message.error('保存失败'))
            .finally(() => this.btnLoading = false)
      })
    },
  }
}
</script>

<style scoped>
.page-wrap{ padding:12px }
.toolbar{ display:flex; align-items:center; margin-bottom:12px }
.pager{ margin-top:12px; text-align:right }
</style>
